import { alpha } from '@mui/system';
import { themeObject as theme } from 'lib';

export const getTruncatedChipLabel = (label: string): string => {
    return label.length > 20 ? label.slice(0, 20) + '...' : label;
};

export const indexViewStyles = {
    card: {
        p: '16px 16px 24px 18px',
        border: `1px solid ${theme.palette.grayScale[300]}`,
        borderRadius: '5px',
        backgroundColor: theme.palette.background.default,
        cursor: 'pointer',
    },
    containerBox: {
        display: 'flex',
    },
    iconBox: {
        mr: 2,
        mt: 1,
    },
    contentBox: {
        width: '100%',
    },
    infoBox: {
        display: 'flex',
        justifyContent: 'space-between',
        mb: 1,
    },
    nameBox: {
        display: 'flex',
        mt: '10px',
    },
    typeIcon: {
        display: 'inline-block',
        width: 'auto',
        margin: '0 auto',
        height: '41px',
    },
    text: {
        mr: 1,
        fontFamily: 'Raleway',
        fontWeight: 600,
        fontSize: '20px',
        lineHeight: '23.48px',
        color: theme.palette.grayScale[800],
    },
    nametext: {
        fontWeight: 500,
        width: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    typetext: {
        mr: 0.5,
        fontFamily: 'Red Hat Text',
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '21.17px',
        color: theme.palette.grayScale[800],
    },
    typeTextValue: {
        fontWeight: 400,
    },
    tooltipIcon: {
        color: theme.palette.primary[400],
    },
    tooltipIconButton: {
        mt: -1,
        mr: -1,
    },
    menuText: {
        ml: 2,
        fontSize: '18px',
        color: theme.palette.grayScale[700],
    },
    menuIcon: {
        fontSize: '1.5rem',
        color: theme.palette.grayScale[500],
    },
    attributeText: {
        mb: '12px',
        fontFamily: 'Raleway',
        fontWeight: 600,
        fontSize: '18px',
        lineHeight: '21.13px',
        color: theme.palette.grayScale[800],
    },
    attributeBox: {
        display: 'flex',
        flexWrap: 'wrap',
        ml: '-6px',
    },
    attributeContainer: {
        mt: '17px',
    },
    menuStyles: {
        '& .MuiPaper-root': {
            width: '108px',
            height: '55px',
            borderRadius: '12px',
            boxShadow: `0px 3px 14px 2px ${alpha(
                theme.palette.grayScale[700],
                0.12
            )},0px 8px 10px 1px ${alpha(
                theme.palette.grayScale[700],
                0.14
            )},0px 5px 5px -3px ${alpha(theme.palette.grayScale[700], 0.2)}`,
        },
    },
    chipStyles: {
        m: '6px',
    },
    addNewIndexButtonStyles: {
        borderRadius: '64px',
        width: '99px',
        height: '34px',
        '& .MuiTypography-root': {
            fontFamily: 'Red Hat Text',
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '24px',
            color: theme.palette.grayScale[700],
            ml: '3px',
        },
    },
    emptyStateContainer: {
        mt: 20,
    },
};
